import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'contacts',
    routes: [
        {
            path: '/contacts',
            meta: {
                layout: 'app',
                permissions: [AppPermissions.ManageContacts],
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                // Contacts
                {
                    path: '',
                    name: 'contacts',
                    component: () => import('#modules/contacts/pages/index.vue'),
                },
                {
                    path: '/contact/new',
                    name: 'new contact',
                    component: () => import('#modules/contacts/pages/contact/create.vue'),
                },
                {
                    path: '/contact/:contact/edit',
                    name: 'edit contact',
                    component: () => import('#modules/contacts/pages/contact/edit.vue'),
                },
                {
                    path: '/contact/:contact',
                    name: 'single contact',
                    component: () => import('#modules/contacts/pages/contact/show.vue'),
                },
                // Companies
                {
                    path: '/company/new',
                    name: 'new company',
                    component: () => import('#modules/contacts/pages/company/create.vue'),
                },
                {
                    path: '/company/:company/edit',
                    name: 'edit company',
                    component: () => import('#modules/contacts/pages/company/edit.vue'),
                },
                {
                    path: '/company/:company',
                    name: 'single company',
                    component: () => import('#modules/contacts/pages/company/show.vue'),
                },
            ],
        },
    ],
});
